// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchItem_root__39V57","leftSide":"SearchItem_leftSide__JA3P-","rightSide":"SearchItem_rightSide__41669"};